export default "__VITE_ASSET__C3S4Ihk7__"